import { ComponentStyle, DiyComponent } from '@/components/DiyEditor/util'
import { cloneDeep } from 'lodash-es'

/** 菜单导航属性 */
export interface MenuSwiperProperty {
  // 布局： 图标+文字 | 图标
  layout: 'iconText' | 'icon'
  // 行数
  row: number
  // 列数
  column: number
  // 导航菜单列表
  list: MenuSwiperItemProperty[]
  // 组件样式
  style: ComponentStyle
}
/** 菜单导航项目属性 */
export interface MenuSwiperItemProperty {
  // 图标链接
  iconUrl: string
  // 标题
  title: string
  // 标题颜色
  titleColor: string
  // 链接
  url: string
  // 角标
  badge: {
    // 是否显示
    show: boolean
    // 角标文字
    text: string
    // 角标文字颜色
    textColor: string
    // 角标背景颜色
    bgColor: string
  }
}

export const EMPTY_MENU_SWIPER_ITEM_PROPERTY = {
  iconUrl: '',
  title: '标题',
  titleColor: '#333',
  url: '',
  badge: {
    show: false,
    text: '',
    textColor: '#fff',
    bgColor: '#E93323'
  }
} as MenuSwiperItemProperty

const badgeOff = () =>
  ({
    show: false,
    text: '',
    textColor: '#fff',
    bgColor: '#E93323'
  }) as MenuSwiperItemProperty['badge']

/** 新建组件默认八宫格（iconUrl 留空 → C 端用品牌默认包；上传 OSS 图后优先展示） */
const defaultItems: MenuSwiperItemProperty[] = [
  {
    iconUrl: '',
    title: '拼团',
    titleColor: '#333',
    url: '/pages/modules/mall/activity/groupon/list',
    badge: badgeOff()
  },
  {
    iconUrl: '',
    title: '秒杀',
    titleColor: '#333',
    url: '/pages/modules/mall/activity/seckill/list',
    badge: badgeOff()
  },
  {
    iconUrl: '',
    title: '充值',
    titleColor: '#333',
    url: '/pages/modules/mall/pay/recharge',
    badge: badgeOff()
  },
  {
    iconUrl: '',
    title: '领券',
    titleColor: '#333',
    url: '/pages/modules/mall/coupon/list',
    badge: badgeOff()
  },
  {
    iconUrl: '',
    title: '签到',
    titleColor: '#333',
    url: '/pages/modules/mall/app/sign',
    badge: badgeOff()
  },
  {
    iconUrl: '',
    title: '分销',
    titleColor: '#333',
    url: '/pages/modules/mall/commission/index',
    badge: badgeOff()
  },
  {
    iconUrl: '',
    title: '商品',
    titleColor: '#333',
    url: '/pages/modules/mall/goods/list',
    badge: badgeOff()
  },
  {
    iconUrl: '',
    title: '收藏',
    titleColor: '#333',
    url: '/pages/modules/mall/user/goods-collect',
    badge: badgeOff()
  }
]

// 定义组件
export const component = {
  id: 'MenuSwiper',
  name: '菜单导航',
  icon: 'bi:grid-3x2-gap',
  property: {
    layout: 'iconText',
    row: 2,
    column: 4,
    list: cloneDeep(defaultItems),
    style: {
      bgType: 'color',
      bgColor: '#fff',
      marginBottom: 8,
      marginLeft: 8,
      marginRight: 8,
      paddingTop: 8,
      paddingRight: 8,
      paddingBottom: 8,
      paddingLeft: 8,
      borderRadius: 8,
      borderTopLeftRadius: 8,
      borderTopRightRadius: 8,
      borderBottomRightRadius: 8,
      borderBottomLeftRadius: 8
    } as ComponentStyle
  }
} as DiyComponent<MenuSwiperProperty>
